export class Customer {
    constructor(customer) {
        this.status         = false;
        this.id             = customer.id;
        this.full_name      = customer.full_name;
        this.type           = customer.type;
        this.visit_count    = customer.visit_count;
        this.last_visited   = customer.last_visited;
        this.lifetime_point= customer.lifetime_point;
        this.current_point  = customer.current_point;
        this.is_send_sms    = customer.is_send_sms;
        this.email          = customer.email;
        this.create_at      = customer.create_at;
        this.phone          = customer.phone;
        this.source         = customer.source;
    }

    changeStatus(status) {
        if(status != '') {
            this.status = status;
        } else {
            this.status = !this.status;
        }
        // console.log(this.status, this.full_name);
    }
}